import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import { SignInPage } from "./views/pages/SignInPage/SignInPage";
import './fgs/scss/styles.scss';
import { getAuthToken } from './fgs/context/RequestContext';

class App extends Component {

  renderRoutes() {
    if (getAuthToken()) {
      return <Route component={DashboardLayout} />;
    }

    return <Redirect to="/signin" />;
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/signin" component={SignInPage} />
          {this.renderRoutes()}
        </Switch>
      </BrowserRouter>

    );
  }
}

export default App;
